import { sortFunction } from "components/MainSearch/Functions";
import { Tab } from "../Types";
import {
  DebtorARSearchResult,
  DebtorCaseSearchResult,
  DebtorSearchResult,
} from "reducers/GlobalSearch/Types";

/**
 * @function
 * @description To get the debtor search results filtered based on the formik input values.
 * @param debtors debtor search results
 * @param tabInfo The formik input values
 * @returns sorted list of debtor search results based on the formik input values for filtering
 */
export const getDebtorValSorted = (
  debtors: DebtorSearchResult[] | [],
  {
    sortKey,
    sortOrder,
  }: Tab<DebtorSearchResult & DebtorARSearchResult & DebtorCaseSearchResult>
): DebtorSearchResult[] | [] => {
  try {
    let levelOfDebtorSort: "DEBTOR" | "AR" | "CASE" = "CASE";
    if (!debtors || debtors.length === 0) {
      levelOfDebtorSort = "CASE";
    } else if (
      Object.keys(debtors.length > 0 ? debtors[0] : []).some(
        (debtorKey) => debtorKey == sortKey
      )
    ) {
      levelOfDebtorSort = "DEBTOR";
    } else if (
      Object.keys(debtors ? debtors[0].arDetails[0] : []).some(
        (arkey) => arkey == sortKey
      )
    ) {
      levelOfDebtorSort = "AR";
    }

    if (!debtors || debtors.length === 0) {
      return debtors;
    }
    if (levelOfDebtorSort === "DEBTOR") {
      return debtors.sort((value1, value2) =>
        sortFunction(
          value1[sortKey as keyof DebtorSearchResult],
          value2[sortKey as keyof DebtorSearchResult],
          sortOrder
        )
      );
    } else if (levelOfDebtorSort === "AR") {
      return (debtors as DebtorSearchResult[]).map((debtor) => ({
        ...debtor,
        arDetails: debtor.arDetails.sort((value1, value2) =>
          sortFunction(
            value1[sortKey as keyof DebtorARSearchResult],
            value2[sortKey as keyof DebtorARSearchResult],
            sortOrder
          )
        ),
      }));
    } else if (levelOfDebtorSort === "CASE") {
      return (debtors as DebtorSearchResult[]).map((debtor) => ({
        ...debtor,
        arDetails: (debtor.arDetails as DebtorARSearchResult[]).map(
          (ardetail) => ({
            ...ardetail,
            caseDetails: ardetail.caseDetails.sort((value1, value2) =>
              sortFunction(
                value1[sortKey as keyof DebtorCaseSearchResult],
                value2[sortKey as keyof DebtorCaseSearchResult],
                sortOrder
              )
            ),
          })
        ),
      }));
    } else {
      return debtors;
    }
  } catch (e) {
    return [];
  }
};
